import { render, staticRenderFns } from "./inbound-call-deadend-icon.vue?vue&type=template&id=4bd2a23c"
import script from "./inbound-call-deadend-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-deadend-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd2a23c')) {
      api.createRecord('4bd2a23c', component.options)
    } else {
      api.reload('4bd2a23c', component.options)
    }
    module.hot.accept("./inbound-call-deadend-icon.vue?vue&type=template&id=4bd2a23c", function () {
      api.rerender('4bd2a23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-call-deadend-icon.vue"
export default component.exports